export type TRowExpandedProps = {
  label: string;
  children?: React.ReactNode;
};

export const TRowExpanded = ({ children }: TRowExpandedProps) => {
  return <>{children}</>;
};
